<template >
  <div><div v-if="loader" id="loader"></div>
    <div class="sm-grid">
      <Grid
        ref="grid"
        v-bind:style="{ height: gridHeight + 'px' }"
        :data-items="items"
        :columns="columns"
        :sortable="true"
        :sort="sort"
        :pageable="pageable"
        :skip="skip"
        :take="take"
        :total="total"
        :page-size="pageSize"
        @pagechange="pageChangeHandler"
        @sortchange="sortChangeHandler"
        :resizable="true"
        @Acknowledge="Acknowledge"
         :expand-field="'expanded'"
        :detail="detailComponent"
        @expandchange="expandChange"
      >
        <grid-toolbar>
          <div class="searchbox">
            <input
              type="text"
              v-model="searchText"
              class="form-control search_mobile"
              placeholder="Search"
            />
          </div>
        </grid-toolbar>
      </Grid>
    </div>
  </div>
</template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("deviceMonitoring");
import Acknowledge from "../ListSos/Acknowledgement.vue";
import { notify, notifyApiError } from '@/utils/notification-helper';
import { MESSAGES } from '@/utils/constants';
import DetailComponent from "./DetailComponent.vue";
import Vue from "vue";

export default {
  data() {
    return {
      gridHeight: window.innerHeight - 160,
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        pageSizes: [5, 10, 25, 100, 500],
      },
      searchText: "",
      sort: [{ field: "name", dir: "asc" }],
        detailComponent: DetailComponent,
      columns: [
        {
          hidden: false,
          field: "imei",
          title: "IMEI",
          width: "150px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "deviceType",
          title: "Device Type",
          width: "100px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "isRegisteredInListener",
          title: "Registered In Listener",
          width: "120px",
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "isRegisteredInConsumer",
          title: "Registered In Consumer",
          width: "150px",
          checked: true,
          defaultSelected: false,
        },
        { cell: Acknowledge, title: "Actions", locked: "true",  width: "150px" ,height:"200px" },
      ],
    };
  },
  methods: {
      sortChangeHandler: function (e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    async getDataOnload() {
      this.$store.dispatch("deviceMonitoring/getUnRegisteredData");
    },
     expandChange(event) {
      const isExpanded =
        event.dataItem.expanded === undefined
          ? event.dataItem.aggregates
          : event.dataItem.expanded;
      Vue.set(event.dataItem, "expanded", !isExpanded);
    },
    Acknowledge(e){
      this.$store.dispatch("deviceMonitoring/acknowledgeUnRegisterData" ,e.dataItem.imei) .then(() => {
          notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        })
        .catch(notifyApiError);
    }
  },
  mounted() {
    this.getDataOnload();
  },
  computed: {
     ...mapState(['loader']),
    total() {
      return this.getUnRegisteredData ? this.getUnRegisteredData.length : 0;
    },
    getUnRegisteredData() {
      return this.$store.getters["deviceMonitoring/unRegisteredData"];
    },
    items: {
      get: function () {
        return orderBy(
          this.getUnRegisteredData
            .slice(this.skip, this.take + this.skip)
            .filter(
              (data) =>
                JSON.stringify(data)
                  .toLowerCase()
                  .indexOf(this.searchText.toLowerCase()) !== -1
            ),
          this.sort
        );
      },
    },
  },
};
</script>
<style lang="scss" scoped >
.searchbox {
  float: right;
}
 .k-grid-header .k-header {
 background-color: red;
        height: 120px;
        padding: 0;
      }
       .k-grid tbody tr {
        line-height: 14px;
      }

      .k-grid tbody td {
        padding: 0;
      }

</style>